import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { connect } from "react-redux";
import { compose } from "redux";
import * as actions from "../../redux/index";
import * as Yup from "yup";
import Header from "../../containers/Header";
import style from "../Login/Login.module.css";
import ttmLodader from "../../assets/images/ttm-loader.gif";
import history from "../../utils/history";

export class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      queryParams: "",
    };
  }

  errorMsg() {
    if (this.props.errorMsg) {
      return <div className="text-danger">{this.props.errorMsg}</div>;
    }
  }

  notify() {
    if (this.state.queryParams !== "")
      return (
        <div className="text-success text-center font-weight-bold">
          Email activation successfull
        </div>
      );
  }

  componentDidMount() {
    document.title = 'Login - TechToMedix';
    this.setState({
      queryParams: this.props.location.search,
    });
    setTimeout(() => {
      this.setState({
        queryParams: "",
      });
    }, 6000);
  }

  render() {
    //console.log("**********", this.props.loading);
    return (
      <React.Fragment>
        <Header />
        {/* <ToastContainer hideProgressBar /> */}
        <div className={style.loginMainWrapper}>
          <div className="container h-100">
            <div className={`row ${style.alignCenter}`}>
              <div className="col-md-12">
                <Formik
                  initialValues={{
                    email: "",
                    password: "",
                  }}
                  //Validation schema
                  validationSchema={Yup.object().shape({
                    email: Yup.string()
                      .email("Email is invalid")
                      .required("Email is required"),
                    password: Yup.string().required("Password is required"),
                  })}
                  //Post data to API
                  onSubmit={async (data, actions) => {
                    await this.props.signIn(data);
                    // if(this.props.isAuthenticated){
                    //   history.push("/dashboard");
                    // }
                  }}
                  render={({ isSubmitting, errors, status, touched }) => (
                    <Form>
                      {this.notify()}
                      <h2 className="ff-montserrat-sb text-center">Login</h2>
                      <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <Field
                          name="email"
                          type="text"
                          className={
                            `form-control ${style.customFormControl}` +
                            (errors.email && touched.email ? " is-invalid" : "")
                          }
                        />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <Field
                          type="password"
                          id="password"
                          name="password"
                          className={
                            `form-control ${style.customFormControl}` +
                            (errors.password && touched.password
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="password"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                      {/* Error Messages */}
                      {this.errorMsg()}
                      <div className="form-group mt-4">
                        <button
                          type="submit"
                          className={`btn btn-block techtomed-btn-primary ${style["techtomed-btn-primary"]}`}
                        >
                          login
                        </button>
                      </div>
                      <p className="text-center">
                        Click here to{" "}
                        <Link to="/register" className={style.loginText}>
                          Register
                        </Link>
                      </p>
                      <p class="text-center">
                        Forgot your password?{" "}
                        <Link to="/resetpassword" className={style.loginText}>
                          Reset Here
                        </Link>
                      </p>

                      {this.props.loading && (
                        <div className={style.loadingWrapper}>
                          <img src={ttmLodader} className="loader-image" />
                        </div>
                      )}
                    </Form>
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    errorMsg: state.userAuth.errorMessage,
    loading: state.userAuth.loading,
    isAuthenticated: state.userAuth.isAuthenticated,
  };
};

export default compose(connect(mapStateToProps, actions))(Login);
